<div class="row">
  <div class="col-lg-4 col-md-6 col-sm-12">
    <h5 i18n="@@NewCustomerNoteHeader">Neue Kundennotiz</h5>
    <form [formGroup]="formService.form" *ngIf="formCreated">
      <div class="form-group mb-3">
        <label for="first-name" i18n="@@SubjectLabel">Betreff</label>
        <input id="subject" formControlName="subject" type="text" class="form-control" i18n-placeholder="@@SubjectPlaceholder" placeholder="Betreff">
        <div class="error">
          <em *ngIf="formService.validateControl('subject') && formService.hasError('subject', 'required')" i18n="@@SubjectRequiredError">Betreff wird benötigt</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label id="message_label" for="message" class="required" i18n="@@MessageNoteLabel">Nachricht/Notiz</label>
        <textarea id="content" formControlName="content" rows="5" class="form-control"></textarea>
        <div class="error">
          <em *ngIf="formService.validateControl('content') && formService.hasError('content', 'required')" i18n="@@ContentRequiredError">Nachricht wird benötigt</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label for="first-name" i18n="@@AuthorLabel">Ersteller</label>
        <input id="author" formControlName="author" type="text" class="form-control" i18n-placeholder="@@MaxMutermannPlaceHolder" placeholder="Max Mustermann">
        <div class="error">
          <em *ngIf="formService.validateControl('author') && formService.hasError('author', 'required')" i18n="@@AuthorRequiredError">Ersteller wird benötigt</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <button (click)="clearInput()" id="delete_input" class="btn btn-danger" i18n="@@DeleteInputButton">Eingabe löschen</button>
        <button (click)="saveNote()" id="save" class="btn btn-save  ms-1" [disabled]="!formService.form.valid" i18n="@@SaveButton">Änderungen speichern</button>
      </div>
    </form>
  </div>

  <div class="col-lg-4 col-md-6 col-sm-12">
    <h5 i18n="@@HistoryOverviewHeader">
      Verlaufsübersicht
    </h5>
    <div class="form-group">
      <label for="first-name" i18n="@@SearchLabel">Suche</label>
      <input class="form-control" id="search" type="text" name="searchTerm" [(ngModel)]="searchTerm" (input)="search()"/>
    </div>
    <span *ngIf="customerNotesFiltered?.length == 0" i18n="@@NoNotesAvailableMessage">Keine Notizen vorhanden.</span>
    <div class="list-group notes-list">
      <div class="list-group-item list-group-item-action" *ngFor="let note of customerNotesFiltered">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{ note.subject }}</h5>
          <small>{{ note.timestamp | dateDE }}</small>
        </div>

        <form [formGroup]="editForm" (ngSubmit)="onEditSubmit(editForm.value)" *ngIf="formCreated">
          <div [ngStyle]="{'display': isEditingEnabled(note) == true ? 'block' : 'none' }">
            <div class="form-group">
              <input formControlName="subject" id="edit_subject" type="text" class="form-control">
            </div>
            <div class="form-group">
              <textarea formControlName="content" id="edit_content" rows="5" class="form-control"></textarea>
            </div>
            <button type="submit" id="save_edit" class="btn btn-save me-2" i18n="@@SaveButton">Änderungen speichern</button>
            <button type="button" id="cancel_edit" class="btn btn-yellow" (click)="cancelEdit()" i18n="@@CloseButton">Schließen</button>
          </div>
        </form>

        <div class="d-flex">
          <div class="mr-auto">
            <p class="mb-1" [ngStyle]="{'display': isEditingEnabled(note) == true ? 'none' : 'block' }">{{ note.content }}</p>
          </div>
          <div>
            <a [routerLink]="[]" id="edit_note" (click)="editNote(note)">
              <span class="material-icons icon-centered" i18n="@@EditButton">edit</span>
            </a>
          </div>
          <div class="ms-2">
            <a [routerLink]="[]" id="delete_note" (click)="showConfirmDeleteDialog(note)">
              <span class="material-icons icon-centered" i18n="@@DeleteButton">delete</span>
            </a>
          </div>
        </div>

        <small class="text-muted" i18n="@@Author">Ersteller: {{ note.author }}</small>
      </div>
    </div>
  </div>

  <div class="col-sm-12 col-md-6 col-lg-4" *ngIf="masterUser">
    <h5 i18n="@@CustomerInfoHeader">Kundeninformationen</h5>
    <div class="form-group mb-2">
      <label>
        <strong i18n="@@CustomerNumberLabel">Kundennummer</strong>
      </label>
      <input type="text" id="readonly_customer_number" class="form-control fw-bold" value="{{ customer.customerId }}" readonly />
    </div>
    <div class="form-group mb-2">
      <label i18n="@@RegisterDateLabel">Registrierungsdatum</label>
      <input type="text" id="readonly_date" class="form-control" value="{{ masterUser.registrationDate | date }}" readonly />
    </div>
    <div class="form-group mb-2">
      <label i18n="@@GenderLabel">Anrede</label>
      <input type="text" id="readonly_gender" class="form-control" value="{{ masterUser.genderDisplay }}" readonly />
    </div>
    <div class="form-group mb-2">
      <label for="first-name" i18n="@@FirstNameLabel">Vorname</label>
      <input type="text" id="readonly_firstname" class="form-control" value="{{ masterUser.firstName }}" readonly />
    </div>
    <div class="form-group mb-2">
      <label for="last-name" i18n="@@LastNameLabel">Nachname</label>
      <input type="text" id="readonly_lastname" class="form-control" value="{{ masterUser.lastName }}" readonly />
    </div>
    <div class="form-group mb-2">
      <label for="street" i18n="@@StreetNumberLabel">Straße / Nr.</label>
      <input type="text" id="readonly_steet" class="form-control" value="{{ masterUser.street }}" readonly />
    </div>
    <div class="row">
      <div class="form-group col-4 mb-2">
        <label for="postalcode" i18n="@@PostCodeLabel">PLZ</label>
        <input type="text" id="readonly_postcode" class="form-control" value="{{ masterUser.postcode }}" readonly />
      </div>
      <div class="form-group col-8 mb-2">
        <label for="city" i18n="@@CityLabel">Ort</label>
        <input type="text" id="readonly_city" class="form-control" value="{{ masterUser.city }}" readonly />
      </div>
    </div>
    <div class="form-group mb-2">
      <label for="tel" i18n="@@TelephoneLabel">Telefon</label>
      <input type="tel" id="readonly_tel" class="form-control" value="{{ masterUser.phone }}" readonly/>
    </div>
  </div>
</div>
